<template>
  <choose-channels-dialog
    v-model="localParticipants"
    :channel-footer="true"
    :base-url="postableUrl"
    items-selectable
    :title="$t('news.create.choose_channels.title')"
    has-fixed-bottom-button
  >
    <template #submit>
      <div>
        <b-form-group class="mb-0 mt-2">
          <b-button type="submit"
                    size="lg"
                    data-cy="submit-invitees"
                    block
                    variant="primary"
                    @click="update"
          >
            {{ $t('calendar.event_creation.participants.submit') }}
          </b-button>
        </b-form-group>
      </div>
    </template>
  </choose-channels-dialog>
</template>

<script>
import ChooseChannelsDialog from 'src/components/miscellaneous/ui/dialogs/ChooseChannelsDialog.vue'
import { Channel, User } from 'src/store/models/index.js'
import Users from '@/api/users.js'

export default {
  name: 'EventCreationModalParticipants',
  components: { ChooseChannelsDialog },
  props: {
    event: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    localParticipants: [],
  }),

  emits: ['update'],

  computed: {
    postableUrl () {
      return `${Users.selfPostableChannelsUrl()}?order-by=name&`
    }
  },

  methods: {
    update() {
      // Update event in wrapper component
      this.$emit('update', {
        ...this.event,
        // split participants by channel and user so API can correctly handle them
        channels: this.localParticipants.filter((s) => s instanceof Channel),
        users: this.localParticipants.filter((s) => s instanceof User),
      })
      this.$router.go(-1)
    },
  },

  watch: {
    event: {
      handler: function (event) {
        // Underlying component ChooseChannelsDialog expects types like Channel or User -> transform them
        this.localParticipants = [...event.channels.map((channel) => new Channel(channel)), ...event.users.map((user) => new User(user))]
      },

      immediate: true,
    },
  },
}
</script>
